import React,{useState,useEffect} from 'react';
import {useParams } from 'react-router-dom';
import YouTubeIcon from '@mui/icons-material/YouTube';
import './searchID.css';

function SearchID(){
   
    const[srval,upsrval]=useState([]);
    
    const params=useParams();

    const GetData=async()=>{
        const res= await fetch(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${params.searchid}`);
        const realdata=await res.json();
        upsrval(realdata.meals[0])
        
    }
    useEffect(()=>{
        GetData();
    },[])

   
    

    return (
        <>
          <h1 className='h1searchmain'>{srval.strArea} FOOD</h1>
          <div>

          <div className='searchdiv'>
              <div className='searchmain'>
                <img src={srval.strMealThumb}  className='mealthumb'/>
                 <h3>{srval.strMeal}</h3>
                 <div>
                   <h2>Watch On</h2>
                   <a href={srval.strYoutube} target='_blank'>
                    <YouTubeIcon />
                   </a>
                 </div>
              </div>

                <div className='searchsaman'>
                  <h3>Ingredient</h3>

            <div className='photosaman'>
                {(srval.strIngredient1==""||srval.strIngredient1==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient1}.png`}/>
                <p>{srval.strIngredient1}</p>
                <p>{srval.strMeasure1}</p>
                </div>}
                 {(srval.strIngredient2==""||srval.strIngredient2==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient2}.png`}/>
                <p>{srval.strIngredient2}</p>
                <p>{srval.strMeasure2}</p>
                </div>}
                 {(srval.strIngredient3==""||srval.strIngredient3==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient3}.png`}/>
                <p>{srval.strIngredient3}</p>
                <p>{srval.strMeasure3}</p>
                </div>}
                 {(srval.strIngredient4==""||srval.strIngredient4==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient4}.png`}/>
                <p>{srval.strIngredient4}</p>
                <p>{srval.strMeasure4}</p>
                </div>}
                 {(srval.strIngredient5==""||srval.strIngredient5==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient5}.png`}/>
                <p>{srval.strIngredient5}</p>
                <p>{srval.strMeasure5}</p>
                </div>}
                 {(srval.strIngredient6==""||srval.strIngredient6==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient6}.png`}/>
                <p>{srval.strIngredient6}</p>
                <p>{srval.strMeasure6}</p>
                </div>}
                 {(srval.strIngredient7==""||srval.strIngredient7==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient7}.png`}/>
                <p>{srval.strIngredient7}</p>
                <p>{srval.strMeasure7}</p>
                </div>}
                 {(srval.strIngredient8==""||srval.strIngredient8==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient8}.png`}/>
                <p>{srval.strIngredient8}</p>
                <p>{srval.strMeasure8}</p>
                </div>}
                 {(srval.strIngredient9==""||srval.strIngredient9==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient9}.png`}/>
                <p>{srval.strIngredient9}</p>
                <p>{srval.strMeasure9}</p>
                </div>}
                 {(srval.strIngredient10==""||srval.strIngredient10==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient10}.png`}/>
                <p>{srval.strIngredient10}</p>
                <p>{srval.strMeasure10}</p>
                </div>}
                 {(srval.strIngredient11==""||srval.strIngredient11==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient11}.png`}/>
                <p>{srval.strIngredient11}</p>
                <p>{srval.strMeasure11}</p>
                </div>}
                {(srval.strIngredient12==""||srval.strIngredient12==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient12}.png`}/>
                <p>{srval.strIngredient12}</p>
                <p>{srval.strMeasure12}</p>
                </div>}
                 {(srval.strIngredient13==""||srval.strIngredient13==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient13}.png`}/>
                <p>{srval.strIngredient13}</p>
                <p>{srval.strMeasure13}</p>
                </div>}
                 {(srval.strIngredient14==""||srval.strIngredient14==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient14}.png`}/>
                <p>{srval.strIngredient14}</p>
                <p>{srval.strMeasure14}</p>
                </div>}
                 {(srval.strIngredient15==""||srval.strIngredient15==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient15}.png`}/>
                <p>{srval.strIngredient15}</p>
                <p>{srval.strMeasure15}</p>
                </div>}
                 {(srval.strIngredient16==""||srval.strIngredient16==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient16}.png`}/>
                <p>{srval.strIngredient16}</p>
                <p>{srval.strMeasure16}</p>
                </div>}
                 {(srval.strIngredient17==""||srval.strIngredient17==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient17}.png`}/>
                <p>{srval.strIngredient17}</p>
                <p>{srval.strMeasure17}</p>
                </div>}
                 {(srval.strIngredient18==""||srval.strIngredient18==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient18}.png`}/>
                <p>{srval.strIngredient18}</p>
                <p>{srval.strMeasure18}</p>
                </div>}
                 {(srval.strIngredient19==""||srval.strIngredient19==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient19}.png`}/>
                <p>{srval.strIngredient19}</p>
                <p>{srval.strMeasure19}</p>
                </div>}
                 {(srval.strIngredient20==""||srval.strIngredient20==null)?null:
                <div className='childphoto'>
                <img src={`https://www.themealdb.com/images/ingredients/${srval.strIngredient20}.png`}/>
                <p>{srval.strIngredient20}</p>
                <p>{srval.strMeasure20}</p>
                </div>}
                  </div>
              </div>
          </div>
            <div className='instructiondiv'>
              <h1 className='instructionname'>instructions</h1>
              <h1 className='instruction'>{srval.strInstructions}</h1>
            </div>
          </div>
    </>
    )
       
}

export default SearchID;